import React from "react";
import { Field, ErrorMessage, useFormikContext } from "formik";
import { FaDiscord, FaGamepad, FaRegHandRock, FaMask, FaBook } from "react-icons/fa";
import { FaNoteSticky } from "react-icons/fa6";
import FormField from "../components/FormField";
import { Checkbox } from "../components/ui/checkbox";
import { cn } from "../lib/utils";

const DOMAINS = [
  { value: "Cosplay",               icon: FaMask,    label: "Cosplay"                },
  { value: "Culture Geek",          icon: FaGamepad, label: "Culture Geek"           },
  { value: "Culture de l'imaginaire", icon: FaBook,  label: "Culture de l'imaginaire" },
];

export const Step2 = () => {
  const { values } = useFormikContext();

  return (
    <div className="h-full flex flex-col gap-4 step-enter">

      <div>
        <h2 className="text-base font-bold text-foreground">Utile à l'association</h2>
        <p className="text-xs text-muted-foreground mt-0.5">
          Ces informations nous aident à vous intégrer à notre communauté.
        </p>
      </div>

      {/* Pseudo Discord */}
      <FormField
        name="idDiscord"
        label="Pseudo Discord"
        icon={FaDiscord}
        hasInfo
        infoTitle="Pourquoi Discord ?"
        info="Cette information est recueillie afin de pouvoir vous inviter à rejoindre le serveur Discord de l'association."
        required
      />

      {/* Domaines de pratique */}
      <div className="flex flex-col gap-2">
        <label className="flex items-center gap-1.5 text-xs font-semibold text-foreground/75 uppercase tracking-wide select-none">
          <FaGamepad className="h-3 w-3 text-primary" />
          Domaine de pratique <span className="text-secondary font-bold">*</span>
        </label>

        <div className="grid grid-cols-3 gap-2">
          {DOMAINS.map(({ value, icon: Icon, label }) => (
            <Field key={value} name="domainePratique">
              {({ field, form }) => {
                const checked = field.value?.includes(value);
                return (
                  <label className={cn(
                    "flex items-center gap-2.5 px-3 py-2.5 rounded-lg border-2 cursor-pointer transition-all duration-150 select-none",
                    checked
                      ? "border-primary bg-primary/10 text-primary"
                      : "border-border/60 hover:border-primary/40 hover:bg-muted/30 text-foreground"
                  )}>
                    <Checkbox
                      checked={checked}
                      onCheckedChange={(c) => {
                        const cur = field.value || [];
                        form.setFieldValue(
                          "domainePratique",
                          c ? [...cur, value] : cur.filter((v) => v !== value)
                        );
                      }}
                    />
                    <Icon className="h-3.5 w-3.5 shrink-0" />
                    <span className="text-xs font-medium leading-tight">{label}</span>
                  </label>
                );
              }}
            </Field>
          ))}
        </div>
        <ErrorMessage name="domainePratique" component="p" className="text-[10px] text-destructive" />
      </div>

      {/* Motivation */}
      <FormField
        name="motivation"
        label="Quelles sont vos motivations ?"
        icon={FaRegHandRock}
        as="textarea"
        rows={3}
        required
      />

      {/* Champs conditionnels */}
      {values.domainePratique?.includes("Cosplay") && (
        <FormField name="cosplay" label="Quels sont tes cosplays ?" icon={FaMask} as="textarea" rows={2} />
      )}
      {values.domainePratique?.includes("Culture Geek") && (
        <FormField name="cultureGeek" label="Ton domaine favori dans la culture geek ?" icon={FaGamepad} as="textarea" rows={2} />
      )}
      {values.domainePratique?.includes("Culture de l'imaginaire") && (
        <FormField name="cultureImaginaire" label="Les univers de l'imaginaire que tu apprécies le plus ?" icon={FaBook} as="textarea" rows={2} />
      )}
    </div>
  );
};
